import { ClientProxy } from '../../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../../base/models'
import { IDashBoardOrderDataRequest, IDashBoardOrderDataResponse } from '../models/models'

export class DashBoardOrderDataApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'general/dashBoardOrderData',
      requesterInfo,
    })
  }

  public async dashBoardOrderData(request: IDashBoardOrderDataRequest): Promise<IDashBoardOrderDataResponse[]> {
    return await this.postAsync<IDashBoardOrderDataResponse[]>(request)
  }
}
